import React from 'react';
import StaticTemplate from '../StaticTemplate';
import Issuers from './Issuers';
import Sponsors from './Sponsors';
import styles from '../Company/Company.module.scss';
import URL from '@/creditflowresearch/Router/urlConstants';
import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';

const pages = [
  {
    name: 'Issuers',
    id: 'issuers-tab-id',
    path: URL.ISSUERS_LIST,
    component: Issuers,
    metaTitle: metaTags.getCatalogIssuers().title,
    metaDescription: metaTags.getCatalogIssuers().description,
  },
  {
    name: 'Parents',
    id: 'sponsors-tab-id',
    path: URL.SPONSORS_LIST,
    component: Sponsors,
    metaTitle: metaTags.getCatalogSponsors().title,
    metaDescription: metaTags.getCatalogSponsors().description,
  },
];

const Catalog = () => (
  <StaticTemplate
    className={ styles.pageContainer }
    pages={ pages }
  />
);

export default Catalog;
